import e from "./_arrayLikeKeys.js";
import i from "./_baseKeysIn.js";
import a from "./isArrayLike.js";
function t(r) {
  return a(r) ? e(r, !0) : i(r);
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/keysIn.js
// module id = 242
// module chunks = 41